// @flow
import React, { useMemo, type Node } from 'react'
import { useTranslation } from 'react-i18next'

import { Api, createApiData } from 'app/common/context/Api'

export const MenuComplexes = createApiData()

const makeRequestsData = (id, date, sellPointId, t, schoolId, sellPointsNotRequired) =>
  id && date && (sellPointId || sellPointsNotRequired)
    ? {
        menuComplexes: {
          path: 'cafeteria/customer/menu/complexes',
          type: 'get',
          rest: {
            params: {
              customer_id: id,
              school_id: schoolId,
              date,
              ...(sellPointId ? { sale_point_id: sellPointId } : {}),
            },
          },
          cbErrorTextCreate: (/* error */) =>
            t('menu_kits_fetch_error', 'Не удалось получить комплекты меню столовой'),
          autoRequest: true,
        },
      }
    : {}

export type ComplexDishApiType = {
  title: string,
  portion: string,
  cost: number,
}

export type ComplexApiType = {
  guid: string,
  available: boolean,
  title: string,
  cost: number,
  free_for_sale: boolean,
  items: Array<ComplexDishApiType>,
}

type State = {
  content: {
    complexes: {
      [string]: ComplexApiType,
    },
  },
  loading: boolean,
  request: {
    menuComplexes: (void) => Promise<void>,
  },
  error?: { [string]: mixed },
}

type Props = {
  personId?: number,
  sellPointId?: number | null,
  date?: string,
  children: Node | ((value: State) => Node),
  schoolId?: number,
  sellPointsNotRequired?: boolean,
}

const initialContent = {
  complexes: {},
}

const MenuComplexesApi = ({
  children,
  personId,
  sellPointId,
  date,
  schoolId,
  sellPointsNotRequired,
}: Props) => {
  const { t } = useTranslation('cafeteria')
  const descriptions = useMemo(
    () => makeRequestsData(personId, date, sellPointId, t, schoolId, sellPointsNotRequired),
    [personId, date, sellPointId, t, schoolId, sellPointsNotRequired],
  )

  return (
    <Api apiData={MenuComplexes} descriptions={descriptions} initialContent={initialContent}>
      {children}
    </Api>
  )
}

export default MenuComplexesApi
